<template>
    <div>
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Mahnwesen') }}
        </h3>
        <div
            class="kgr-alert kgr-alert--info kgr-row"
            v-html="$t('club.dunningSettings.infoText.general')"
        ></div>

        <kgr-checkbox
            v-model="clubDunningSettings.enabled"
            class="mb1"
            :label="$t('Mahnwesen aktivieren')"
        />

        <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
            <div class="kgr-grid__cell">
                <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                    {{ $t('Zahlungsfristen ab Rechnungsdatum') }}
                </h3>
                <div
                    class="kgr-alert kgr-alert--info kgr-row"
                    v-html="$t('club.dunningSettings.infoText.deadlines')"
                ></div>
                <kgr-form-row
                    :label="$t('Rechnung')"
                    :error="error"
                    field-name="invoicePaymentDeadline"
                >
                    <input
                        v-model.trim="clubDunningSettings.invoicePaymentDeadline"
                        type="number"
                        min="0"
                        class="kgr-input"
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('Zahlungserinnerung')"
                    :error="error"
                    field-name="clubDunningLevel1[paymentDeadline]"
                >
                    <input
                        v-model.trim="clubDunningSettings.clubDunningLevel1.paymentDeadline"
                        type="number"
                        min="0"
                        class="kgr-input inputWithCheckbox"
                    />
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel1.enabled"
                        class="mb1 activator"
                        :label="$t('aktiv')"
                        @change="toggleDialog()"
                    />
                </kgr-form-row>
                <div style="clear:both;"></div>
                <kgr-form-row
                    :label="$t('1. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel2[paymentDeadline]"
                >
                    <input
                        v-model.trim="clubDunningSettings.clubDunningLevel2.paymentDeadline"
                        type="number"
                        min="0"
                        class="kgr-input inputWithCheckbox"
                    />
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel2.enabled"
                        class="mb1 activator"
                        :label="$t('aktiv')"
                    />
                </kgr-form-row>
                <div style="clear:both;"></div>
                <kgr-form-row
                    :label="$t('2. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel3[paymentDeadline]"
                >
                    <input
                        v-model.trim="clubDunningSettings.clubDunningLevel3.paymentDeadline"
                        type="number"
                        min="0"
                        class="kgr-input inputWithCheckbox"
                    />
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel3.enabled"
                        class="mb1 activator"
                        :label="$t('aktiv')"
                    />
                </kgr-form-row>
                <div style="clear:both;"></div>
                <kgr-form-row
                    :label="$t('3. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel4[paymentDeadline]"
                >
                    <input
                        v-model.trim="clubDunningSettings.clubDunningLevel4.paymentDeadline"
                        type="number"
                        min="0"
                        class="kgr-input inputWithCheckbox"
                    />
                    <kgr-checkbox
                        v-model="clubDunningSettings.clubDunningLevel4.enabled"
                        class="mb1 activator"
                        :label="$t('aktiv')"
                    />
                </kgr-form-row>
                <div style="clear:both;"></div>
            </div>

            <div class="kgr-grid__cell">
                <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                    {{ $t('Mahngebühren') }}
                </h3>
                <div
                    class="kgr-alert kgr-alert--info kgr-row"
                    v-html="$t('club.dunningSettings.infoText.fees')"
                ></div>
                <kgr-form-row
                    :label="$t('Beitragskategorie')"
                    :error="error"
                    field-name="clubFeeCategoryId"
                >
                    <kgr-dropdown
                        v-model="clubDunningSettings.clubFeeCategory"
                        :options="clubFeeCategories"
                        display="name"
                        @post-input="filterClubFeesByCategory"
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('Zahlungserinnerung')"
                    :error="error"
                    field-name="clubDunningLevel1[clubFeeId]"
                >
                    <kgr-dropdown
                        v-model="clubDunningSettings.clubDunningLevel1.clubFee"
                        :options="filteredClubFees1"
                        display="name"
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('1. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel2[clubFeeId]"
                >
                    <kgr-dropdown
                        v-model="clubDunningSettings.clubDunningLevel2.clubFee"
                        :options="filteredClubFees2"
                        display="name"
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('2. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel3[clubFeeId]"
                >
                    <kgr-dropdown
                        v-model="clubDunningSettings.clubDunningLevel3.clubFee"
                        :options="filteredClubFees3"
                        display="name"
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('3. Mahnung')"
                    :error="error"
                    field-name="clubDunningLevel4[clubFeeId]"
                >
                    <kgr-dropdown
                        v-model="clubDunningSettings.clubDunningLevel4.clubFee"
                        :options="filteredClubFees4"
                        display="name"
                    />
                </kgr-form-row>
            </div>
        </div>

        <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
            <div class="kgr-grid__cell">
                <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                    {{ $t('Rücklastschrift') }}
                </h3>
                <kgr-form-row
                    :label="$t('Rücklastschriftgebühr')"
                    :error="error"
                    field-name="clubFeeForChargeback"
                >
                    <kgr-dropdown
                        v-model="clubDunningSettings.clubFeeForChargeback"
                        :options="clubFees"
                        display="name"
                    />
                </kgr-form-row>
            </div>
        </div>

        <kgr-generic-modal
            :value="showDialog"
            :headline="$t('club.dunningSettings.dunningLevel1.deactivate.title')"
            @post-input="cancelDialog()"
        >
            <div v-html="$t('club.dunningSettings.dunningLevel1.deactivate.text')"></div>
            <template #footer>
                <kgr-button
                    class="kgr-col"
                    @click="closeDialog()"
                >
                    {{ $t('Ok') }}
                </kgr-button>
                <kgr-button
                    type="grey"
                    @click="cancelDialog()"
                >
                    {{ $t('cancel') }}
                </kgr-button>
            </template>
        </kgr-generic-modal>
    </div>
</template>

<script>
import Button from '../../common/form/button/KgrButton';
import Checkbox from '../../common/form/checkbox/Checkbox';
import ClubDunningSettings from '../../../js/dto/ClubDunningSettings';
import Dropdown from '../../common/form/select/Dropdown';
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import GenericModal from '../../common/modal/GenericModal.vue';

export default {
    components: {
        'kgr-button': Button,
        'kgr-checkbox': Checkbox,
        'kgr-dropdown': Dropdown,
        'kgr-form-row': FormRow,
        'kgr-generic-modal': GenericModal,
    },
    props: {
        clubFees: {
            type: Array,
            required: true,
        },
        clubFeeCategories: {
            type: Array,
            required: true,
        },
        clubDunningSettings: {
            type: ClubDunningSettings,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            filteredClubFees1: [],
            filteredClubFees2: [],
            filteredClubFees3: [],
            filteredClubFees4: [],
            showDialog: false,
        };
    },
    watch: {
        clubDunningSettings() {
            this.setDunningLevelClubFee();
            this.setClubFeeForChargeback();
            this.setDunningLevelClubFeeCategory();
            this.filterClubFeesByCategory();
        },
    },
    created() {
        this.setDunningLevelClubFee();
        this.setClubFeeForChargeback();
        this.setDunningLevelClubFeeCategory();
        this.filterClubFeesByCategory();
    },
    methods: {
        setDunningLevelClubFee() {
            this.clubDunningSettings.clubDunningLevel1.clubFee = this.filterClubFee(this.clubDunningSettings.clubDunningLevel1.clubFee);
            this.clubDunningSettings.clubDunningLevel2.clubFee = this.filterClubFee(this.clubDunningSettings.clubDunningLevel2.clubFee);
            this.clubDunningSettings.clubDunningLevel3.clubFee = this.filterClubFee(this.clubDunningSettings.clubDunningLevel3.clubFee);
            this.clubDunningSettings.clubDunningLevel4.clubFee = this.filterClubFee(this.clubDunningSettings.clubDunningLevel4.clubFee);
        },
        setClubFeeForChargeback() {
            this.clubDunningSettings.clubFeeForChargeback = this.filterClubFee(this.clubDunningSettings.clubFeeForChargeback);
        },
        filterClubFee(assignedClubFee) {
            const clubFeeId = assignedClubFee !== null ? assignedClubFee.id : null;
            const clubFees = this.clubFees.filter((clubFee) => clubFee.id === clubFeeId);
            return clubFees.length === 1 ? clubFees[0] : null;
        },
        setDunningLevelClubFeeCategory() {
            const clubFeeCategoryId = this.clubDunningSettings.clubFeeCategory !== null ? this.clubDunningSettings.clubFeeCategory.id : null;
            const clubFeesCategories = this.clubFeeCategories.filter((clubFeeCategory) => clubFeeCategory.id === clubFeeCategoryId);
            this.clubDunningSettings.clubFeeCategory = clubFeesCategories.length === 1 ? clubFeesCategories[0] : null;
        },
        filterClubFeesByCategory() {
            const clubFeeCategoryId = this.clubDunningSettings.clubFeeCategory !== null ? this.clubDunningSettings.clubFeeCategory.id : null;
            let filteredClubFees = [];
            if (clubFeeCategoryId !== null) {
                filteredClubFees = this.clubFees.filter((clubFee) => clubFee.category !== null && clubFee.category.id === clubFeeCategoryId);
                this.filteredClubFees1 = [...filteredClubFees];
                this.filteredClubFees2 = [...filteredClubFees];
                this.filteredClubFees3 = [...filteredClubFees];
                this.filteredClubFees4 = [...filteredClubFees];
                if (this.clubDunningSettings.clubDunningLevel1.clubFee !== null
                    && !this.filteredClubFees1.includes(this.clubDunningSettings.clubDunningLevel1.clubFee)) {
                    this.filteredClubFees1.push(this.clubDunningSettings.clubDunningLevel1.clubFee);
                }
                if (this.clubDunningSettings.clubDunningLevel2.clubFee !== null
                    && !this.filteredClubFees2.includes(this.clubDunningSettings.clubDunningLevel2.clubFee)) {
                    this.filteredClubFees2.push(this.clubDunningSettings.clubDunningLevel2.clubFee);
                }
                if (this.clubDunningSettings.clubDunningLevel3.clubFee !== null
                    && !this.filteredClubFees3.includes(this.clubDunningSettings.clubDunningLevel3.clubFee)) {
                    this.filteredClubFees3.push(this.clubDunningSettings.clubDunningLevel3.clubFee);
                }
                if (this.clubDunningSettings.clubDunningLevel4.clubFee !== null
                    && !this.filteredClubFees4.includes(this.clubDunningSettings.clubDunningLevel4.clubFee)) {
                    this.filteredClubFees4.push(this.clubDunningSettings.clubDunningLevel4.clubFee);
                }
            } else {
                this.filteredClubFees1 = this.clubFees;
                this.filteredClubFees2 = this.clubFees;
                this.filteredClubFees3 = this.clubFees;
                this.filteredClubFees4 = this.clubFees;
            }
        },
        toggleDialog() {
            if (!this.clubDunningSettings.clubDunningLevel1.enabled) {
                this.showDialog = true;
            }
        },
        closeDialog() {
            this.showDialog = false;
        },
        cancelDialog() {
            this.clubDunningSettings.clubDunningLevel1.enabled = true;
            this.closeDialog();
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.inputWithCheckbox {
    width: 90%;
    float: left;
    margin-right: 10px;
}
.activator {
    float: left;
    margin-top: 5px;
}
</style>
